import { defineStore } from 'pinia';
import { ServiceSettings } from '@/models/settings';

export const useServiceStore = defineStore('service', {
    state: () => ({
        selected: {} as ServiceSettings,
        isSelected: false,
    }),

    actions: {
        selectService(service: ServiceSettings) {
            if (service) {
                this.isSelected = true
                this.selected = service
            } else {
                this.clearSelection()
            }
        },
        clearSelection() {
            this.isSelected = false;
            this.selected = {} as ServiceSettings;
        }
    }
});